module.exports = __webpack_public_path__ + "static/media/tachometer-fastest.0462871f.svg";